import React from "react";
import { GoogleMaps } from "../GoogleMaps/GoogleMaps";

export const Delivery = () => {
  return <GoogleMaps orderType="delivery" />;
};
